export function mediaIdFromUrl(url) {
  if (!url) return null;
  const m = url.match(/\/media\/([^/?#]+)/);
  return m ? m[1] : null;
}
